import { useEffect, useState } from 'react';

import { useAuth } from 'providers/AuthProvider';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';

const DEFAULT_LOCATION = { lat: 40.7128, lon: -74.006, city: 'New York' };

export const useUserLocation = () => {
  const { logged } = useAuth();
  const { currentUser } = useCurrentUser();
  const [userLocation, setUserLocation] = useState(DEFAULT_LOCATION);

  useEffect(() => {
    if (logged && currentUser?.location) {
      setUserLocation({
        lat: currentUser.location.lat ?? DEFAULT_LOCATION.lat,
        lon: currentUser.location.lon ?? DEFAULT_LOCATION.lon,
        city: currentUser.location.city || DEFAULT_LOCATION.city,
      });
      return;
    }

    setUserLocation(DEFAULT_LOCATION);
  }, [logged, currentUser]);

  return userLocation;
};
